module.exports = __webpack_public_path__ + "static/media/laptop-phone-v3.e10dc6af.png";